import { DateTime } from 'luxon';
import Link from 'next/link';
import { FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { AuthRoutes } from 'routes';

export default function Footer() {
  const currentYear = DateTime.now().year;

  return (
    <footer className="w-full border-t border-[#363636] bg-dark px-[4rem] pb-[2rem] pt-[4rem] text-white">
      <div className="mx-auto flex max-w-[82.125rem] flex-col gap-[3rem]">
        <div className="grid grid-cols-1 gap-[3rem] md:grid-cols-2 lg:grid-cols-4">
          {/* Quick Links */}
          <div>
            <div className="mb-[1.5rem] text-[1.125rem] font-bold">Quick Links</div>
            <ul className="space-y-[0.75rem] text-[1rem] font-light">
              <li className="cursor-pointer">
                <Link href={AuthRoutes.TheraStart}>Home</Link>
              </li>
              <li className="cursor-pointer">
                <a href="https://app.getthera.com" target="_blank" rel="noopener noreferrer">
                  Login
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/book-a-demo" target="_blank" rel="noopener noreferrer">
                  Book Demo
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/payroll" target="_blank" rel="noopener noreferrer">
                  Payroll
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/invoicing" target="_blank" rel="noopener noreferrer">
                  AP/AR
                </a>
              </li>
            </ul>
          </div>

          {/* Platform */}
          <div>
            <div className="mb-[1.5rem] text-[1.125rem] font-bold">Platform</div>
            <ul className="space-y-[0.75rem] text-[1rem] font-light">
              <li className="cursor-pointer">
                <a href="https://getthera.com/us-payroll" target="_blank" rel="noopener noreferrer">
                  US Payroll
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/contractor-management" target="_blank" rel="noopener noreferrer">
                  Contractor Management
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/employer-of-record" target="_blank" rel="noopener noreferrer">
                  Employer of Record
                </a>
              </li>
            </ul>
          </div>

          {/* Compare */}
          <div>
            <div className="mb-[1.5rem] text-[1.125rem] font-bold">Compare</div>
            <ul className="space-y-[0.75rem] text-[1rem] font-light">
              <li className="cursor-pointer">
                <a
                  href="https://getthera.com/alternatives/remote-alternative"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Remote Alternative
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/alternatives/gusto-alternative" target="_blank" rel="noopener noreferrer">
                  Gusto Alternative
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/alternatives/veem-alternative" target="_blank" rel="noopener noreferrer">
                  Veem Alternative
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/alternatives/ontop-alternative" target="_blank" rel="noopener noreferrer">
                  Ontop Alternative
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/alternatives/deel-alternative" target="_blank" rel="noopener noreferrer">
                  Deel Alternative
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <div className="mb-[1.5rem] text-[1.125rem] font-bold">Resources</div>
            <ul className="space-y-[0.75rem] text-[1rem] font-light">
              <li className="cursor-pointer">
                <a href="https://intercom.help/thera/en" target="_blank" rel="noopener noreferrer">
                  Help Center
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/why-thera" target="_blank" rel="noopener noreferrer">
                  About
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/blog" target="_blank" rel="noopener noreferrer">
                  Blog
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/customers" target="_blank" rel="noopener noreferrer">
                  Customers
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/testimonials" target="_blank" rel="noopener noreferrer">
                  Testimonials
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/library" target="_blank" rel="noopener noreferrer">
                  Library
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/partners" target="_blank" rel="noopener noreferrer">
                  Affiliates
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/terms" target="_blank" rel="noopener noreferrer">
                  Terms of Service
                </a>
              </li>
              <li className="cursor-pointer">
                <a href="https://getthera.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col gap-[1rem] border-t border-[#363636] pt-[2rem]">
          <div className="text-[0.875rem] font-extralight text-white">© Thera {currentYear}, All Rights Reserved</div>
          <div className="text-[0.875rem] font-extralight text-white">1460 Broadway, New York, NY 10036</div>

          {/* Social Icons */}
          <div className="flex gap-[1rem]">
            <a
              href="https://twitter.com/getthera"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
              className="flex h-[2rem] w-[2rem] cursor-pointer items-center justify-center rounded-md bg-[#3b3b3b] text-white transition hover:bg-[#2970FF]"
            >
              <FaTwitter size={16} />
            </a>
            <a
              href="https://www.linkedin.com/company/getthera/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="flex h-[2rem] w-[2rem] cursor-pointer items-center justify-center rounded-md bg-[#3b3b3b] text-white transition hover:bg-[#2970FF]"
            >
              <FaLinkedinIn size={16} />
            </a>
          </div>

          {/* Disclaimer */}
          <div className="mt-[1rem] text-[0.75rem] font-extralight leading-relaxed text-gray-400">
            <p className="mb-[0.5rem]">
              Thera is a financial technology company, not a bank. Banking services are provided by OMB Bank, Member
              FDIC. Deposits in checking and savings accounts are held by OMB Bank and are eligible for FDIC insurance
              coverage. FDIC insurance covers the failure of an insured bank; pass-through insurance applies only if
              specific conditions are met. Fees, terms, and conditions may apply. Please review our{' '}
              <a href="https://getthera.com/terms" target="_blank" rel="noopener noreferrer" className="underline">
                Terms of Service
              </a>{' '}
              and{' '}
              <a
                href="https://getthera.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
              >
                Privacy Policy
              </a>
              . Contact us for questions about your privacy and consult a tax advisor for tax-related concerns.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
